export default "__VITE_ASSET__DOA5YP8U__"